import React, { useState, useEffect } from "react";
import { Card, Spin } from "antd";
import { Scatter } from '@ant-design/plots';
import { useSelector, useDispatch } from "react-redux";

import { employeeChart } from "../../constant"

import { FilterDays, FilterSelect } from "../../../../components/TableList";

import { REDUX as REDUX_UTIL } from "../../../../services/util";

import { dashboardHDLR } from "../../../../handlers" 
import { resultEmployeesData } from "../../handler"

import "../../index.css";


const { reduxStoreWrapper } = REDUX_UTIL;

const EmployeeSubmission = (props) => { 
    const { items, selection, loading } = props;

    // const dispatch = useDispatch()

    const company = useSelector(reduxStoreWrapper("company.byID"));
    const dataSubmission = useSelector(reduxStoreWrapper("dashboard.daily.summaries"));
    const employeeProfiles = dataSubmission
    .filter(d => {
        return d.employee_submission_profile && Object.keys(d.employee_submission_profile).length > 0;
      })
    .map(d => ({
        coid: d.coid,
        createdDate: d.createdDate,
        ...d.employee_submission_profile
      }));
      
    const [selectedDays, setSelectedDays] = useState(30);
    const [valueComp, setValueComp] = useState(["ALL"]);
    const [employeesData, setEmployeesData] = useState(employeeProfiles);
    const [isFilter, setIsFilter] = useState(false);
    const [load, setLoad] = useState(false);

    // useEffect(() => {
    //   if(employeeProfiles.length) dashboardHDLR.applyFilters(employeeProfiles, valueComp, selectedDays, setEmployeesData, setIsFilter);
    // }, [employeeProfiles, valueComp, selectedDays]);

    useEffect(() => {
      if (!load && employeeProfiles.length > 0) {
        setEmployeesData(employeeProfiles);
        setLoad(true);
      }
    }, [load, employeeProfiles]);
    
      const applyFilters = (companies, days) => {
        dashboardHDLR.applyFilters(employeeProfiles, companies, days, setEmployeesData, setIsFilter);
      };

    const onChangeSelect = (newValue) => {
        setIsFilter(true);
        setValueComp(newValue);
        applyFilters(newValue, selectedDays);
    };

    const handleOptionDays = (value) => {
        setIsFilter(true);
        setSelectedDays(value);
        applyFilters(valueComp, value);
    };

    const transformedData = resultEmployeesData(employeesData)

    const config = employeeChart(transformedData)

    return (
        <Card className="row-space card-shadow height-card">
            <div className="header-card">
                <span className="title-card">Employee Submission Profile</span>
                <FilterDays
                    defaultValue={selectedDays}
                    items={items}
                    handleChange={handleOptionDays}
                />
                <FilterSelect 
                    selection={selection}
                    style={{ width: 160, height: 32, marginLeft: "4px"}}
                    selectedData={valueComp}
                    onChangeSelect={onChangeSelect}
                />
            </div>
            <div style={{width: "102%", height: "470px", marginLeft: "-10px", marginTop: "0.5vh"}}>
                {loading || Object.values(company).length === 0 || isFilter ? (
                    <Spin style={{width: "102%", height: "470px", display: "flex", alignItems: "center", justifyContent: "center"}} />
                ) : (
                    <Scatter
                        {...config}
                    />
                )}
            </div>
        </Card>
    );
};

export default EmployeeSubmission;